<div class="rest_dra">
    <div class="frm_date_dra">
        <div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
            <div class="title d-flex align-items-center">
              <button  mat-icon-button (click)="navigate()"  class="me-3">
                <mat-icon class="material-icons-round">arrow_back</mat-icon>
              </button>
              <div>
                <h1 >{{pageTitle |titlecase}}</h1>
                <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
            
            <button *ngIf="showButton" mat-button >{{showButton}}</button>
          </div>
        <!-- <div class="row">
            <button (click)="openAddDate()">Add Date</button>
        </div> -->
        <div class="row" style="
        padding-left: 15px">
            
            <div class="col-sm-5 " >
                <div class="res_fll_sed">
                    <div class="row">
                        <div class="col-sm-1">
                            <label>From</label>
                        </div>
                        <div class="col-sm-5" style="
                        padding-left: 20px;
                    ">
                            <input type="date" name="fromDate" [(ngModel)]="fromDate">
                        </div>

                        <div class="col-sm-1">
                            <label class="ret_tde">To</label>
                        </div>
                        <div class="col-sm-5" style="
                        padding-left: 20px;
                    ">
                            <input type="date" name="toDate" [(ngModel)]="toDate">
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="in_btn_dra">
                    <button (click)="search()">Search</button>
                </div>
            </div>
           
        </div>
    </div>
    <!-- <error-exception-comp></error-exception-comp> -->
    <!-- <div class="rest_table table-responsive-lg" *ngIf="earningData.length != 0">
        <table>
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Earning</th>
                    <th>Total Paid</th>
                    <th>Status</th>
                    <th>Notes</th>
                    <th>Option</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of earningData;let i=index;">
                    <td>{{item.transaction_date.slice(0,10) | date: "EEEE, MMM d, y"}}</td>
                    <td>₹ {{item.earning}}</td>
                    <td>₹ {{item.total_paid}}</td>
                    <td>
                        <div class="hm_icon_progr" *ngIf="item.paid_status == 0">
                            <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <div class="hm_icon" *ngIf="item.paid_status == 1">
                            <i class="fa fa-check" aria-hidden="true"></i>
                        </div>
                    </td>
                    <td>{{item.note && item.note != 'null' ? item.note : '-'}}</td>
                    <td>
                        <div class="dropdown icn_plm">
                            <button type="button" class="btn btn-primary dropdown-toggle hvbr" data-toggle="dropdown">
                          <i class="fa fa-ellipsis-h"></i>
                          </button>
                            <div class="dropdown-menu mlq">
                                <a class="dropdown-item" href="javascript:void(0)" (click)="earningsDetails(item)"> View details</a>
                                <a class="dropdown-item" href="javascript:void(0)" (click)="changeStatus(item,'1')" *ngIf="item.paid_status == 0"> Mark Paid</a>
                                <a class="dropdown-item" href="javascript:void(0)" (click)="changeStatus(item,'0')" *ngIf="item.paid_status == 1"> Mark Inprogress</a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div> -->
    <!-- <div class="row">
        <div class="col-sm-12">
            <div *ngIf="earningData.length == 0">
                <div class="pce_hml_text">
                    <div class="gtr_plc">
                        <div class="plt_hlr">
                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 468.28 468.28" style="enable-background:new 0 0 512 512" xml:space="preserve"
                                ><g>
                            <path xmlns="http://www.w3.org/2000/svg"  d="M424.097,370.45v34.393c0,35.035-85.046,63.437-189.957,63.437S44.184,439.878,44.184,404.843V370.45  H424.097z" fill="#f6c358" data-original="#f6c358" ></path>
                            <path xmlns="http://www.w3.org/2000/svg"  d="M424.097,336.854v34.393c0,35.035-85.046,63.437-189.957,63.437S44.184,406.282,44.184,371.247  v-34.393H424.097z" fill="#fcd462" data-original="#fcd462" ></path>
                            <path xmlns="http://www.w3.org/2000/svg"  d="M424.097,303.258v34.393c0,35.035-85.046,63.437-189.957,63.437S44.184,372.686,44.184,337.651  v-34.393H424.097z" fill="#f6c358" data-original="#f6c358" ></path>
                            <path xmlns="http://www.w3.org/2000/svg"  d="M424.097,269.662v34.393c0,35.035-85.046,63.437-189.957,63.437S44.184,339.09,44.184,304.055  v-34.393H424.097z" fill="#fcd462" data-original="#fcd462" ></path>
                            <ellipse xmlns="http://www.w3.org/2000/svg"  cx="234.14" cy="263.58" rx="189.958" ry="63.438" fill="#f6c358" data-original="#f6c358" ></ellipse>
                            <circle xmlns="http://www.w3.org/2000/svg"  cx="278.909" cy="137.865" r="137.865" fill="#fcd462" data-original="#fcd462" ></circle>
                            <path xmlns="http://www.w3.org/2000/svg"  d="M278.935,246.005c-59.63,0-108.14-48.511-108.14-108.138c0-59.63,48.511-108.14,108.14-108.14  c59.628,0,108.138,48.511,108.138,108.14C387.073,197.494,338.562,246.005,278.935,246.005z" fill="#dc8744" data-original="#dc8744" ></path>
                            <path xmlns="http://www.w3.org/2000/svg"  d="M274.57,220.105v-14.484c-18.125-1.849-34.393-9.058-48.812-21.621l14.484-17.261  c11.117,9.656,22.557,15.404,34.328,17.261v-38.494c-14.952-3.568-25.891-8.267-32.834-14.088  c-6.943-5.821-10.423-14.451-10.423-25.891c0-11.44,4.004-20.797,12.005-28.079c8.001-7.274,18.423-11.238,31.252-11.9v-9.922  h12.699v10.116c14.548,1.066,28.305,6.023,41.271,14.887l-12.901,18.254c-8.727-6.216-18.189-10.051-28.37-11.513v37.299h0.597  c15.21,3.576,26.384,8.404,33.529,14.484c7.145,6.087,10.713,14.92,10.713,26.489c0,11.577-4.101,21.007-12.304,28.273  c-8.203,7.282-19.045,11.246-32.536,11.908v14.282H274.57z M260.579,92.037c-3.367,2.971-5.054,6.677-5.054,11.109  c0,4.432,1.316,7.936,3.964,10.512c2.648,2.583,7.67,5.062,15.081,7.444V86.773C268.62,87.306,263.953,89.058,260.579,92.037z   M302.35,179.036c3.698-3.036,5.554-6.87,5.554-11.505c0-4.626-1.461-8.299-4.368-11.012c-2.906-2.713-8.332-5.256-16.268-7.637  v35.709C293.615,183.936,298.645,182.079,302.35,179.036z" fill="#f6c358" data-original="#f6c358" ></path>
                            <g xmlns="http://www.w3.org/2000/svg">
                            </g>
                            </g></svg>
                            <div class="rgt_ted">
                                <h3>No data yet found
                                </h3>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.<br> ever since the 1500s, when an unknown printer took a galley of type and scrambled</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>
<div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>

<mat-card appearance="outlined" *ngIf="visible">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="messageList"
           [showPagination]="true" [itemsPerPage]="5">

           <ng-template #costTemplate let-rowVal="row" let-colVal="col">
            {{rowVal[colVal.columnProperty] | currency: 'INR'}}
          </ng-template>
          
      </sm-data-table>
    </div>
  </mat-card>